<template>
  <div class="outer-wrap">
    <Sidebar
      v-if="this.getStructureDetails"
      :show="showSidebar"
      :adminRights="userHasAdminRight"
      :sensors="this.getStructureDetails.sensors"
      @sidebartoggle="showSidebar = !showSidebar"
      @settingstoggle="
        showSettings = !showSettings;
        showMonitor = false;
        showSidebar = false;
        showAnalogNode = false;
      "
      @monitortoggle="
        showMonitor = !showMonitor;
        showSettings = false;
        showSidebar = false;
        showAnalogNode = false;
      "
      @analog-node-toggle="
        showAnalogNode = !showAnalogNode;
        showMonitor = false;
        showSettings = false;
        showSidebar = false;
      "
    />
    <div id="navbar">
      <NavBar v-show="true" @logout="this.logout" @sidebartoggle="showSidebar = !showSidebar" />
      <div id="general-info">
        <!-- Selezione Struttura -->
        <BridgeOverview
          id="bridge-ow"
          :bridges="this.getStructures"
          :selectedBridge="this.getStructureDetails"
          v-if="this.loaded && this.getStructureDetails"
          @struct-selected="selectStructure"
        />
      </div>
    </div>
    <div class="dashboard" id="page-wrap">
      <!-- Settings -->
      <transition name="settings">
        <Settings id="set" v-if="showSettings" :selectedStructure="this.getStructureDetails" :userType="this.getUserType" @settingstoggle="showSettings = !showSettings" />
      </transition>
      <!-- Monitor -->
      <transition name="settings">
        <Monitor id="monitor" v-if="showMonitor" :selectedStructure="this.getStructureDetails" @monitortoggle="showMonitor = !showMonitor" />
      </transition>
      <!-- Analog Node -->
      <transition name="settings">
        <AnalogNode
          id="analog-node"
          v-if="this.getStructureDetails && showAnalogNode && userHasAdminRight"
          :selectedStructure="this.getStructureDetails"
          @close-me="showAnalogNode = false"
          @need-refresh="this.fetchStructureData"
        />
      </transition>
      <!-- Loading -->
      <transition name="load">
        <LoadingLogo v-if="!this.loaded" />
      </transition>
      <!-- Immagine generica della struttra -->
      <Generic
        id="generic"
        v-if="this.loaded && this.getStructureDetails && this.getStructureDetails.type === 'generic'"
        :selectedSensorFromParent="this.getSelectedSensor"
        :selectedStructure="this.getStructureDetails"
        :editable="false"
        @sensor-selected="setSelectedSensor"
      />
      <bridgeInfo id="bridge-inf" :structureDetails="this.getStructureDetails" v-if="this.loaded && this.getStructureDetails && this.getStructureDetails.type != 'generic'" />
      <!-- Overview Statistiche -->
      <overviewInfo v-if="this.loaded && this.getStructureDetails && this.getSensorType !== 'analog-node' && !isLambro" />

      <!-- Grafico Displacement -->
      <lastevents v-if="this.loaded && this.getStructureDetails && !isLambro" />

      <!-- Controllo Opzioni del Trend -->
      <trendControl
        :nSpans="this.getStructureDetails.spans"
        :sensors="this.getStructureDetails.sensors"
        v-if="this.getSensorType === 'deck' && this.loaded && this.getStructureDetails"
      />

      <!-- Grafici dei Trend -->
      <trend v-if="this.getSensorType === 'deck' && this.loaded && this.getStructureDetails" />
      <!-- Deformata -->
      <div class="sub-wrapper" v-if="this.getStructureDetails && this.getStructureDetails._id && this.getSensorType === 'tiltmeter'">
        <Deflection v-for="(span, index) in spans" :spanNumber="index + 1" :spanName="span.name" :spanLength="span.length" :key="index" :structureDetails="getStructureDetails" />
      </div>
      <Footer />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import lastevents from "../components/modules/dashboard/lastevents.vue";
import bridgeInfo from "../components/modules/dashboard/bridgeInfo.vue";
import trend from "../components/modules/dashboard/trend.vue";
import Deflection from "../components/modules/dashboard/deflection.vue";
import BridgeOverview from "../components/ui/BridgeOverview.vue";
import NavBar from "../components/ui/NavigationBar.vue";
import overviewInfo from "../components/modules/dashboard/overviewInfo.vue";
import trendControl from "../components/modules/dashboard/trendControl.vue";
import LoadingLogo from "../components/ui/LoadingLogo";
import Sidebar from "../components/ui/Sidebar.vue";
import Settings from "./Settings";
import Monitor from "./Monitor";
import AnalogNode from "./AnalogNode";
import Footer from "../components/ui/Footer";
import Generic from "../components/structures/generic";
import $ from "jquery";

export default {
  name: "dashboard",
  components: {
    lastevents,
    NavBar,
    bridgeInfo,
    trend,
    Deflection,
    BridgeOverview,
    overviewInfo,
    trendControl,
    LoadingLogo,
    Sidebar,
    Settings,
    Monitor,
    Generic,
    AnalogNode,
    Footer,
  },
  // Props per forzare la selezione da route precedente
  props: {
    selectedSensorID: String,
    selectedStructureID: String,
  },
  data() {
    return {
      loaded: false,
      showSidebar: false,
      showSettings: false,
      showMonitor: false,
      showAnalogNode: false,
    };
  },
  methods: {
    ...mapActions({
      fetchStructures: "structure/fetchStructures",
      selectStructure: "structure/selectStructure",
      fetchStructureData: "structure/fetchStructureData",
      setSelectedSensor: "lastevents/setSelectedSensor",
      logout: "auth/logout",
      fetchUserSettings: "user/fetchUserSettings",
    }),
    saveSensorsSettings: function () {},
    setupNavigationSticky: function () {
      // Setta l'hiding automatico della Navigation Bar
      var prevScrollpos = window.pageYOffset;
      window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos - currentScrollPos > 0) {
          $("#navbar").css("-webkit-transform", "translateY(0px");
          $("#navbar").css("transform", "translateY(0px");
        } else {
          if (currentScrollPos > 50) {
            $("#navbar").css("-webkit-transform", "translateY(-150px");
            $("#navbar").css("transform", "translateY(-150px");
          }
        }
        prevScrollpos = currentScrollPos;
      };
    },
  },
  watch: {
    getSelectedStructure: {
      // Chiamata quando chiama la struttura selezionata
      handler: async function (newValue) {
        if (newValue) {
          this.loaded = false;
          await this.fetchStructureData();
          this.loaded = true;
        }
      },
      deep: true,
    },
    getStructureDetails: {
      // Aggiorna le info sul sensore attualmente selezionato
      handler: async function (newValue, oldValue) {
        if (oldValue && this.getSelectedSensor) {
          let euiSelected = this.getSelectedSensor.eui;
          let newItem = newValue.sensors.find((x) => x.eui === euiSelected);
          this.setSelectedSensor(newItem);
          //this.loaded = true;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      getStructures: "structure/getStructures",
      getSensors: "structure/getSensors",
      getSelectedStructure: "structure/getSelectedStructure",
      getStructureDetails: "structure/getStructureDetails",
      getSensorType: "lastevents/getSensorType",
      getSelectedSensor: "lastevents/getSelectedSensor",
      getUserType: "user/getUserType",
    }),
    isLambro() {
      return this.getSensors ? this.getSensors.some((sn) => sn.eui === "C0EE400001015144") : false;
    },
    userHasAdminRight() {
      return !this.getUserType || this.getUserType === "standard";
    },
    spans() {
      return this.getStructureDetails && this.getStructureDetails.userConfig ? this.getStructureDetails.userConfig.spansDetails : [];
    },
  },
  async mounted() {
    // Viene effettuato il fetch delle strutture
    await this.fetchStructures();
    await this.fetchUserSettings();
    if (!this.getSelectedStructure) {
      await this.selectStructure(this.getStructures[0]);
    }
    await this.setupNavigationSticky();
    /* console.log("Struttura selezionata da Router", this.selectedStructureID);
    console.log("Sensore selezionato da Router", this.selectedSensorID); */
    $(document).on("keydown", function (event) {
      if (event.keyCode == 9) {
        //tab pressed
        event.preventDefault(); // stops its action
      }
    });
  },
};
</script>
<style scoped>
* {
  font-size: 1em;
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-family: "Poppins", sans-serif;
}
/* NavBar */
#navbar {
  transition: transform 0.3s;
  position: fixed;
  width: 100%;
  min-width: 840px;
  z-index: 999999;
  /* Transizioni usate per la Sidebar */
  -webkit-transition: transform 0.6s ease-in-out;
  -moz-transition: transform 0.6s ease-in-out;
  -o-transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
}
#general-info {
  height: 60px;
  background-color: transparent;
  width: 100%;
  top: 50px;
  left: 0;
  position: absolute;
  -webkit-transition: transform 0.6s ease-in-out;
  -moz-transition: transform 0.6s ease-in-out;
  -o-transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
}

#bridge-ow {
  max-width: 100vw;
}
.dashboard {
  position: absolute;
  display: grid;
  background-color: rgb(32, 34, 47);

  padding-top: 110px;

  width: 100%;
  right: 0px;
  /* Transizioni usate per la Sidebar */
  -webkit-transition: transform 0.6s ease-in-out;
  -moz-transition: transform 0.6s ease-in-out;
  -o-transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
}

#generic {
  margin-top: 40px;
}
/* Tra 600 e 1499 */
@media all and (max-width: 1799px) and (min-width: 300px) {
  .dashboard {
    font-size: 0.8em;
  }
}

/* Loading Transition */
.load-enter,
.load-leave-to {
  opacity: 0;
}
.load-enter-active {
  transition: all 0.3s ease;
}
.load-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

#set {
  z-index: 12;
}

#monitor,
#analog-node {
  z-index: 12;
}
</style>
